import { render, staticRenderFns } from "./BlockedAutoBooks.vue?vue&type=template&id=11897c88&"
import script from "./BlockedAutoBooks.vue?vue&type=script&lang=js&"
export * from "./BlockedAutoBooks.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports